import { useState, useCallback, useMemo } from 'react';

const usePlanFilters = ({ initialFilters = {}, onSetFilter } = {}) => {
  const [filters, setFilters] = useState(() => ({ ...initialFilters }));

  const setFilter = useCallback(
    (name, value) => {
      if (typeof onSetFilter === 'function') {
        onSetFilter(name, value, setFilters);
        return;
      }

      setFilters((prev) => ({
        ...prev,
        [name]: value,
      }));
    },
    [onSetFilter]
  );

  const clearFilter = useCallback((name, value) => {
    setFilters((prev) => {
      if (value === undefined) {
        return { ...prev, [name]: undefined };
      }

      if (Array.isArray(prev[name])) {
        return {
          ...prev,
          [name]: prev[name].filter((v) => v !== value),
        };
      }

      return prev;
    });
  }, []);

  const selected = useMemo(
    () =>
      Object.entries(filters).reduce((acc, [name, item]) => {
        acc[name] = Array.isArray(item) ? item.map((i) => i?.value ?? i) : item;
        return acc;
      }, {}),
    [filters]
  );

  return {
    filters,
    selected,
    setFilter,
    clearFilter,
    setFilters, // optional escape hatch
  };
};

export default usePlanFilters;
